import { Component, Input } from '@angular/core'

@Component({
  selector: 'risk-scale',
  templateUrl: './risk-scale.component.html',
  styleUrls: ['./risk-scale.component.scss'],
})
export class RiskScaleComponent {
  @Input() data: any
}
